import { NgFor } from '@angular/common';
import { Component, HostListener, OnDestroy } from '@angular/core';
import { NavigationEnd, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { Subscription } from 'rxjs';
import { HOME_SECTIONS } from '../../data/home-sections';
import { ScrollSpyService } from '../../services/scroll-spy.service';

@Component({
  selector: 'app-header',
  imports: [NgFor, RouterLink, RouterLinkActive],
  templateUrl: './header.html',
  styleUrl: './header.css',
})
export class Header implements OnDestroy {
  readonly sections = HOME_SECTIONS;
  menuOpen = false;
  isScrolled = false;
  private readonly navSub: Subscription;

  constructor(
    private readonly router: Router,
    public readonly scrollSpy: ScrollSpyService
  ) {
    this.navSub = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        requestAnimationFrame(() => this.syncHeaderState());
      }
    });
  }

  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    this.syncHeaderState();
  }

  ngOnDestroy(): void {
    this.navSub.unsubscribe();
  }

  onLogoClick(): void {
    const baseUrl = this.router.url.split('?')[0].split('#')[0];
    if (baseUrl !== '/') {
      this.scrollSpy.setPendingScrollTop();
      return;
    }

    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }

  onSectionClick(id: string): void {
    if (id === 'about') {
      const baseUrl = this.router.url.split('?')[0].split('#')[0];
      if (baseUrl !== '/') {
        this.scrollSpy.setPendingScrollTop();
        this.router.navigate(['/'], { replaceUrl: true });
        return;
      }
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      return;
    }

    const baseUrl = this.router.url.split('?')[0].split('#')[0];
    if (baseUrl !== '/') {
      this.scrollSpy.setPendingSection(id);
      this.router.navigate(['/'], { replaceUrl: true });
      return;
    }

    this.scrollSpy.scrollTo(id);
  }

  toggleMenu(): void {
    this.menuOpen = !this.menuOpen;
  }

  closeMenu(): void {
    this.menuOpen = false;
  }

  get logoSrc(): string {
    return this.isScrolled ? '/tab-logo-light.webp' : '/tab-logo.webp';
  }

  private syncHeaderState(): void {
    const baseUrl = this.router.url.split('?')[0].split('#')[0];
    if (baseUrl !== '/') {
      this.isScrolled = false;
      return;
    }

    const hero = document.querySelector('.hero') as HTMLElement | null;
    this.isScrolled = hero ? window.scrollY > hero.offsetHeight : false;
  }
}
